<template>
  <v-container fluid>
    <div class="modal-padding">
      <div class="download-title mb-upload-15">Upload OMR Sheet</div>
      <!-- <v-files-input chips multiple label="Upload OMR Sheet" capture="user" model-value="files" ></v-files-input> -->
      <InputFile v-model="files" />
      <v-btn class="cust-btn" color="primary" @click="uploadFiles">Upload</v-btn>
    </div>
  </v-container>
</template>
<script>
import { mapActions,mapState } from "vuex";
import InputFile from "../../common/InputFile.vue";
export default {
  name: "UploadOmrSheet",
  components: { InputFile },
  props: ["onClose",'status'],
  data() {
    return {
      files: [],
    };
  },
  computed: {
        ...mapState("userStore", ["user", "myInstitute"]),
  },
  methods: {
    ...mapActions({
      uploadOmr: "testStore/uploadOmr",
    }),
    onChange(e) {
      this.file = e;
    },
    async validation(){
      let valid = true;
      for (let index = 0; index < this.files.length; index++) {
        const file = this.files[index];
        if (!this.OMR_SUPPORTED_FILE_TYPES.includes(file.type)) {
          valid = false;
          this.$toasted.error(`File type not supported of file ${file.name}`,{icon: 'info'})
          break;
        } 
        
        // const size = this.bytesToSize(file.size);
        // const imgDem = await this.getImageDimensions(file)
        // if (!(size.sizeUnit === 'MB' && size.size >= 1 )){
        //   this.$toasted.error(`File size should be greater than 1MB of file ${file.name}`,{icon: 'info'})
        //   valid = false;
        //   break;
        // }
        // if ((imgDem.width>= imgDem.height))
        // {
        //   this.$toasted.error(`Image width must be less than image height - ${file.name}`,{icon: 'info'})
        //   valid = false;
        //   break;
        // }
      }
      return valid
    },
   async uploadFiles() {
      const files = this.files;
      const formData = new FormData();
      if (await this.validation()) {
        this.$root.showLoader = true;
        
        for (var i = 0; i < files.length; i++ ){
            let file = files[i];
            formData.append('image', file);
        }
  
        formData.append('institute_id',this.myInstitute.id)
        this.uploadOmr(formData)
          .then(res=>{
            this.$root.showLoader = false;
            this.$toasted.success(`${files.length} OMR${files.length>1?'s are':" is"} uploaded successfully. Processing starts in 7 minutes`,{icon : 'info'})
            this.onClose({status:false})
          })
          .catch(err=>{
            this.$root.showLoader = false;
          })
      }
    },
  },

  watch: {
    files(v) {},
    status(val) {
      if (val) {
        this.files = []
      }
    }
  },
};
</script>
